<template>
  <div>
    <div @click="openModal" class="button-substitute" :class="innerClass">
      {{selectedFrs ? selectedFrs.Name : 'Aucun fournisseur'}}
      <i class="substitute-icon"><font-awesome-icon icon="sync-alt"></font-awesome-icon></i>
    </div>

    <Modal :open="modalSearch" title="Choix fournisseur" @close="modalSearch = false">
      <input class="form-control" type="text" v-model="search" ref="searchInput" />
      <ul class="list-group list-group-flush">
        <li class="list-group-item" v-for="fournisseur in displayedFrsList" :key="fournisseur.Guid" v-on:click="$emit('update', fournisseur.Guid); modalSearch = false">{{ fournisseur.Name }} <div class="badge bg-success" v-if="$store.state.self.isAdmin">{{ fournisseur.Guid }}</div></li>
      </ul>
    </Modal>
  </div>
</template>

<script>
  import Vue from "vue";
  import Modal from "./Modal";

  export default {
    name: "Substitute",
    components: { Modal },
    props: [
      "frsList",
      "selectedFrsGuid",
      "innerClass"
    ],
    data() {
      return {
        search: "",
        modalSearch: false
      }
    },
    computed: {
      selectedFrs() {
        if (this.selectedFrsGuid) return this.frsList.find(el => el.Guid == this.selectedFrsGuid);
        return null;
      },
      displayedFrsList() {
        if (!this.frsList) return [];
        return this.frsList.filter(el => el.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1).slice().sort((a, b) => a.Name < b.Name ? -1 : 1)
      }
    },
    methods: {
      openModal() {
        this.modalSearch = true;
        const that = this;
        Vue.nextTick()
          .then(function () {
            that.$refs.searchInput.focus();
          })
      }
    }
  }
</script>

<style scoped>
  .list-group {
    margin-top: 16px;
  }

  .list-group-item {
      display: flex;
      justify-content: space-between;
  }

    .list-group-item:hover {
      cursor: pointer;
      background: #F3F3F3;
    }

  .badge {
      height: max-content;
      margin-left: 24px;
  }

  svg {
      margin-left: 12px;
  }

  .button-substitute {
      background-color: #FFFFFF;
      border: 1px solid #ced4da;
      border-radius: .25rem;
      padding: .375rem .85rem .375rem .75rem;
      -moz-padding-start: calc(0.75rem - 3px);
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
  }

  .substitute-icon {
      float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/Substitute.vue